import firebase from './FirebaseConfig/firebase';
import { useEffect, useState } from 'react';
import 'firebase/auth';
import LandingPageContainer from './Containers/LandingPageContainer';
import NavBarComponent from './Components/NavBarComponent/NavBarComponent';
import { BrowserRouter, Route } from 'react-router-dom';
import './App.css';
import BoardMember from './Components/BoardMemberComponent/BoardMember';
import Footer from './Components/FooterComponent/Footer';
import ProjectPage from './Components/ProjectPageComponent/ProjectPage';
import ProjectCardList from './Components/ProjectCardComponent/projectCardList';
import Test from './Components/testComponent/Test';
import ContactUsResponses from './Components/AdminPanelComponent/ContactUsResponses/ContactUsResponses';
import { StateProvier, useStateValue } from './services/ContextProvider';
import { getGlobalData } from './services/DashboardService';
import { onAuthStateChanged, roles } from './services/AuthService';
import AddProject from './Components/AdminPanelComponent/AddProjectComponent/AddProject';
import AdminPanelContainer from './Containers/AdminDashboardContainer/AdminPanelContainer';
import { LoaderComponent } from './Components/LoaderComponent/LoaderComponent';
import { GuardedRoute } from './services/GuardedRoute';
import AllProjects from './Components/AdminPanelComponent/AllProjectsComponent/AllProjects';
import Aos from 'aos';
import ScrollToTop from './Components/ScrollToTop';


function App() {

    const { globalDispatch, globalState, userDispatch } = useStateValue();
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);

    useEffect(() => {

        onAuthStateChanged(globalDispatch, userDispatch);
        const unsubscribeGlobal = getGlobalData(globalDispatch);
        Aos.init({ duration: 1000 });
        return () => {
            unsubscribeGlobal();
        };
    }, []);
    useEffect(() => setLoading(globalState.globalLoading || globalState.globalAuthLoading), [globalState.globalLoading, globalState.globalAuthLoading]);
    if (loading) {
        return (
            <LoaderComponent />
        );
    }

    return (
        <div >
            <BrowserRouter>
                <NavBarComponent />
                <ScrollToTop />
                {/* {<NavBar user={user} />} */}
                <Route path="/" exact >
                    <LandingPageContainer user={user} />
                </Route>
                <Route path="/ourteam" exact component={BoardMember} />
                <Route path="/projects" component={ProjectCardList} />
                <Route path="/leoproject" exact component={ProjectPage} />
                <Route path="/test" exact component={Test} user={user} />
                <Route path='/addproject' exact component={AddProject} />
                {/* <Route path='/allprojects' exact component={AllProjects} /> */}
                <Route path="/admin-panel">
                    <GuardedRoute Component={AdminPanelContainer} />
                </Route>
                <Footer />
            </BrowserRouter>

        </div>
    );

}

export default App;